<template>
  <div class="details-page">
    <!-- <div class="title"><h4>{{handleType=='add'?'新增客户':'填写客户信息'}}</h4></div> -->
    <!-- <div class="search_box">
      <van-search v-model="searchValue" placeholder="请输入搜索关键词" @search="onSearch" />
    </div>-->
    <div class="top">
      <img v-if="headimgurl==null" src="./img/icon-default.png" alt />
      <img v-else :src="headimgurl" alt />
      <!-- <p class="customeStep">{{nickname}}</p> -->
      <p>
        <span
          class="wxName"
        >{{nickname!="访客"||userInfo.insuredname==''?nickname:userInfo.insuredname}}</span>&nbsp;&nbsp;
        <span class="telNum">{{userInfo.tel}}</span>
      </p>
      <!-- <p class="count">{{userInfo.tel}}</p> -->
    </div>
    <div class="tab">
      <van-tabs
        color="#ff6927"
        v-model="activeTab"
        title-active-color="#ff6927"
        :line-width="tabWidth"
        @click="changeTab"
      >
        <van-tab name="hoby">
          <template #title>
            <img v-if="activeTab=='hoby'" src="./img/like.png" alt />
            <img v-else src="./img/unlike.png" alt />
            客户喜好
          </template>
        </van-tab>
        <van-tab name="info">
          <template #title>
            <img v-if="activeTab=='info'" src="./img/info.png" alt />
            <img v-else src="./img/uninfo.png" alt />
            基本信息
          </template>

          <div class="detailsContent">
            <van-form class="userInfo">
              <van-field
                v-model="userInfo.insuredname"
                :readonly="handleType=='check'?true:false"
                name="姓名"
                label="姓名"
                placeholder="姓名"
                input-align="right"
                :rules="[{ required: true, message: '请填写用姓名' }]"
              />
              <van-field
                v-model="userInfo.tel"
                type="tel"
                name="手机号"
                label="手机号"
                maxlength="11"
                input-align="right"
                :readonly="handleType=='check'?true:false"
                placeholder="手机号"
                :rules="[{ required: true, message: '请填写手机号' }]"
              />
              <van-field
                v-model="userInfo.born"
                type="text"
                name="出生日期"
                label="出生日期"
                placeholder="出生日期"
                @click="showPopup"
                input-align="right"
                readonly
              />
              <!-- <van-field
          v-model="userInfo.adrress"
          type="text"
          name="地址"
          label="地址"
          placeholder="地址"
              />-->
              <van-field
                v-model="userInfo.idno"
                type="number"
                name="身份证"
                label="身份证"
                placeholder="身份证"
                input-align="right"
                :readonly="handleType=='check'?true:false"
              />
              <van-field
                v-model="userInfo.email"
                type="text"
                name="邮箱"
                label="邮箱"
                placeholder="邮箱"
                input-align="right"
                :readonly="handleType=='check'?true:false"
              />
              <van-field
                v-model="userInfo.company"
                type="text"
                name="公司名称"
                label="公司名称"
                placeholder="公司名称"
                input-align="right"
                :readonly="handleType=='check'?true:false"
              />
              <van-field
                v-model="userInfo.job"
                type="text"
                name="职位"
                label="职位"
                placeholder="职位"
                input-align="right"
                :readonly="handleType=='check'?true:false"
              />
              <van-collapse v-model="activeNames">
                <van-collapse-item title="其他" name="1">
                  <van-cell title="婚否">
                    <van-radio-group v-model="userInfo.mateflag" direction="horizontal">
                      <van-radio
                        :disabled="handleType=='check'?true:false"
                        checked-color="#ff6927"
                        name="1"
                      >已婚</van-radio>
                      <van-radio
                        :disabled="handleType=='check'?true:false"
                        checked-color="#ff6927"
                        name="0"
                      >未婚</van-radio>
                    </van-radio-group>
                  </van-cell>
                  <van-cell title="是否有孩子">
                    <van-radio-group v-model="userInfo.has_child" direction="horizontal">
                      <van-radio
                        :disabled="handleType=='check'?true:false"
                        checked-color="#ff6927"
                        name="0"
                      >无</van-radio>
                      <van-radio
                        :disabled="handleType=='check'?true:false"
                        checked-color="#ff6927"
                        name="1"
                      >有</van-radio>
                    </van-radio-group>
                  </van-cell>

                  <!-- <van-cell title="个人收入占比"  />
         <van-cell >
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio name="1">单选框 1</van-radio>
          <van-radio name="2">单选框 2</van-radio>
        </van-radio-group> 
                  </van-cell>-->
                  <van-field
                    v-model="userInfo.selfmonthincome"
                    type="text"
                    name="个人收入"
                    label="个人收入"
                    placeholder="个人收入"
                    input-align="right"
                    :readonly="handleType=='check'?true:false"
                  />
                  <van-field
                    v-model="userInfo.work_place"
                    type="text"
                    name="工作地"
                    label="工作地"
                    placeholder="工作地"
                    input-align="right"
                    readonly
                    @click="showAreaPick('W')"
                  />
                  <van-field
                    v-model="userInfo.live_city"
                    type="text"
                    name="居住地"
                    label="居住地"
                    placeholder="居住地"
                    input-align="right"
                    @click="showAreaPick('L')"
                    readonly
                  />
                </van-collapse-item>
              </van-collapse>
              <div class="subBtn" v-if="handleType!='check'" @click="onSubmit">保存</div>
            </van-form>
            <van-popup v-model="datePick" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                @confirm="checkDate"
              />
            </van-popup>
            <van-popup v-model="areaPick" position="bottom">
              <van-area title="请选择" :area-list="areaList" @confirm="checkArae" />
            </van-popup>
          </div>
        </van-tab>
        <!-- <van-tab name="risk">
              <template #title>
                <img v-if="activeTab=='risk'" src="./img/fx.png" alt="">
                <img v-else src="./img/unfx.png" alt="">
              </template>
        </van-tab>
        <van-tab name="Policy">
              <template #title>
                <img v-if="activeTab=='Policy'" src="./img/bd.png" alt="">
                <img v-else src="./img/unbd.png" alt="">
              </template>
        </van-tab>-->
      </van-tabs>
    </div>
    <div v-show="activeTab=='hoby'">
      <div id="div1" ref="wordBox">
        <img class="hotbg" src="./img/hotbg.png" alt />
        <van-loading
          v-if="hotLoading"
          style="text-align:center;top:70px;position:absolute;width:100%;"
          color="#1989fa"
        >数据加载中...</van-loading>
        <a
          v-show="!hotLoading"
          v-for="(item ,index) in words"
          class="lable"
          :key="index"
          :class="item.class"
        >{{item.word}}</a>
        <p v-if="!hotLoading&&showDafaultText" class="defaultText">暂无客户喜好数据，您可以给客户分享热文来洞察客户喜好。</p>
      </div>
      <div v-if="words.length>0" class="hobyTitle">
        您的客户可能对下列文章感兴趣
        <br />
        <span>您可以通过给客户转发喜欢的内容来增加好感~</span>
      </div>
      <div v-if="words.length>0" class="hobyList">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            class="article_list"
            v-model="loading"
            :immediate-check="false"
            :finished="finished"
            offset="30"
            finished-text="我也是有底线的~~~"
            @load="onLoad"
          >
            <van-row class="van-clearfix">
              <div
                class="list_item"
                v-for="(item,idx) in hobyList"
                :class="{shareing:shareIndex==idx}"
                :key="idx"
              >
                <div v-if="item!==null" class="article_pic_wrap">
                  <van-image
                    height="80"
                    width="80"
                    :src="item.coverlink"
                    fit="cover"
                    error-icon
                    style="border-radius: 3px;overflow: hidden;"
                  />
                  <div class="editBtn" @click="shareAtc(item,idx)">
                    <img src="./img/share0.png" alt />转发
                  </div>
                  <div class="van-multi-ellipsis--l2 article_title">{{item.title}}</div>
                </div>
              </div>
            </van-row>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <van-overlay :show="shareTip" @click="shareTip = false">
      <div class="wrapper" @click.stop>
        <img src="./img/jiantou.png" alt />
        <h4>点击右上角分享~</h4>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant';
import AreaList from './../../clue/area.js';
import wx from "weixin-js-sdk";
import URL from "@/api/api";
export default {
  name: "clueDetails",
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1, //请求第几页
      pageSize: 10, //每页请求的数量
      total: 0, //总共的数据条数
      hobyList: [],
      userInfo: {
        field2:'',//客户id
        insuredname: '', //姓名
        age_td: '', //年龄 
        sex: '',   // 性别   '1-男   2-女     0-不详',
        born: '',  //出生日期
        mateflag: '', //婚否  '1-已婚 0 未婚
        company: '',
        idno: '',
        email: '',
        adrress: '',
        job: '',
        tel: '',  // 手机号
        selfmonthincome: '', //个人月收入
        live_city: '',  //生活城市
        work_place: '',   //工作地
        has_child: '',    // 是否有孩子'  1-有    0-没有  2-2个3-3个    4-4个 5-5个',
        openid: '', //客户openid
        field1: '',//是代理人的openid
        aId:'',//代理人用户id
        field3:''//代理人头像
      },
      areaType: '',
      activeTab: 'hoby',
      activeNames: [],
      datePick: false,
      areaPick: false,
      minDate: new Date(1900, 0, 1),
      // maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      areaList: AreaList,
      handleType: '',
      headimgurl: '',
      nickname: '',
      activitie_id: '',
      tendsType: '',
      tabWidth: '',
      //文字云变量
      radius: 60,
      dtr: Math.PI / 180,
      d: 100,
      //download by http://www.jq22.com
      mcList: [],
      active: false,
      lasta: 1,
      lastb: 1,
      distr: true,
      tspeed: 5,
      size: 50,

      mouseX: 0,
      mouseY: 0,

      howElliptical: 1,

      aA: null,
      oDiv: null,
      sa: '',
      ca: '',
      sb: '',
      cb: '',
      sc: '',
      cc: '',
      textTimer: '',
      words: [],
      appId: '',
      baseUrl: '',
      shareLink: '',
      cardInfo: '',
      articleId: '',
      shareIndex: '-1',
      canMakeWordCloud: false,
      shareTip: false,
      hotLoading: true,
      showDafaultText: false,


    }
  },
  mounted() {
    var that = this;
    this.tabWidth = '16'
    this.activitie_id = this.$route.query.activitie_id;
    this.tendsType = this.$route.query.tendsType;
    this.handleType = this.$route.query.type;
    this.userInfo.field1 = sessionStorage.getItem('openId');
    this.headimgurl = this.$route.query.headimgurl;
    this.nickname = this.$route.query.nickname;
    this.userInfo.openid = this.$route.query.userId;
    this.userInfo.aId=localStorage.getItem('userid')
    this.userInfo.field2=this.$route.query.id
    this.userInfo.field3=this.$route.query.headimgurl
    if (this.nickname == null) {
      this.nickname = "访客";
    }
    if (this.$route.query.type == 'edit') {
      var postData = {
        insuredcode: this.$route.query.insuredcode
      };
      this.getCustomerData(postData)
    }
    if (location.hostname === "zf.dtfcloud.com") {
      this.baseUrl = "https://zf.dtfcloud.com/";
      this.appId = "wxae0168c583647722";
    } else {
      this.baseUrl = "http://www.bjnfbk.com/";
      this.appId = "wx5cfc702e76590e27";
    }
    this.oDiv = document.querySelector('#div1');
    // this.getCustomerHobyWord()
    this.$fetchGet(URL.getCustomerHoby.url, { openid: this.userInfo.openid })
      .then(res => {
        var wodsList = [];
        if (res.data.length == 0 || res == null) {
          this.showDafaultText = true;
        }
        wodsList = res.data;
        for (var i = 0; i < wodsList.length; i++) {
          if (wodsList[i].level == 1) {
            wodsList[i].class = 'first';
          }
          if (wodsList[i].level == 2) {
            wodsList[i].class = 'second';
          }
          if (wodsList[i].level == 3) {
            wodsList[i].class = 'third';
          }
          if (wodsList[i].level == 4) {
            wodsList[i].class = 'fourth';
          }
          if (wodsList[i].level == 5) {
            wodsList[i].class = 'fifth';
          }
          if (wodsList[i].level == 6) {
            wodsList[i].class = 'sexth';
          }
          if (wodsList[i].level == 7) {
            wodsList[i].class = 'seventh';
          }
        }
        this.canMakeWordCloud = true;
        this.words = wodsList;
        setTimeout(function () {
          that.aA = document.getElementsByClassName('lable');
          that.wordCloud();
        }, 3000)

      })
    this.getCustomerHoby()


    // this.getDataList(this.activitie_id,this.tendsType);

  },
  methods: {
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    onChange() {

    },
    onSubmit(values) {
      var that = this;
      var url = "";
      if (this.$route.query.userId && this.$route.query.type == 'edit') {
        this.userInfo.openid = this.$route.query.userId;
        url =URL.updateCustomer.url
      } else {
        url = URL.addCustomer.url
      }
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.userInfo.tel))) {
        Toast('手机号码有误，请检查')
        return;
      }
      // if (this.userInfo.idno !== '' && this.userInfo.idno != null) {
      //   if (!this.validateIdCard(this.userInfo.idno)) {
      //     Toast('请输入正确的身份证号码')
      //     return
      //   }
      // }
      if (this.userInfo.email !== "" && this.userInfo.email != null) {
        var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!reg.test(this.userInfo.email)) {
          Toast("请输入有效的邮箱");
          return
        }
      }
      // return;
      this.$fetchPost(url, that.userInfo)
        .then(res => {
          if (res.data.code == '20000') {
            Toast(res.data.msg);
            setTimeout(function () {
              that.$router.push({
                name: 'clueDetails',
                query: {
                  userId: that.userId,
                  activitie_id: that.activitie_id,
                  tendsType: that.tendsType
                  // tendsType:that.clueType
                }
              })
            }, 1000)

          }
        })
    },
    getCustomerData(obj) {
      
      this.$fetchGet(URL.getCustomerInfo.url, obj)
        .then(res => {
          if (res.data.code == '20000') {
            this.userInfo = res.data.data;
            this.userInfo.aId=localStorage.getItem('userid')
            this.getCard(this.userInfo.field1)
          }

        })

    },
    getCustomerHobyWord(obj) {
      this.$fetchGet(URL.getCustomerHoby.url, { openid: this.userInfo.openid })
        .then(res => {
          var wodsList = [];
          if (res.data.length == 0 || res.data == null) {
            this.showDafaultText = true;
          }
          wodsList = res.data;
          for (var i = 0; i < wodsList.length; i++) {
            if (wodsList[i].level == 1) {
              wodsList[i].class = 'first';
            }
            if (wodsList[i].level == 2) {
              wodsList[i].class = 'second';
            }
            if (wodsList[i].level == 3) {
              wodsList[i].class = 'third';
            }
            if (wodsList[i].level == 4) {
              wodsList[i].class = 'fourth';
            }
            if (wodsList[i].level == 5) {
              wodsList[i].class = 'fifth';
            }
            if (wodsList[i].level == 6) {
              wodsList[i].class = 'sexth';
            }
            if (wodsList[i].level == 7) {
              wodsList[i].class = 'seventh';
            }
          }
          this.canMakeWordCloud = true;
          this.words = wodsList;
          // this.words=[{word: "无", frequency: , font: null}]
          // }

        })

    },
    getCustomerHoby(obj) {
      var that = this;
      that.$fetchPost(URL.getArticleList.url, {
        now_page: that.pageNum,
        row_num: that.pageSize,
        // openid:"o79BZsz7TOyGvQOAOuJgEav-oR6s",
        openid: that.userInfo.openid,
      }).then(res => {
        let list = res.data.list; //请求返回当页的列表
        that.refreshing = false;
        that.loading = false;
        Toast.clear();
        that.total = res.data.total;
        if (list == null || list.length === 0) {
          // 加载结束
          that.finished = true;
          return;
        }
        // 将新数据与老数据进行合并
        if (that.pageNum > 1) {
          that.hobyList = [...that.hobyList, ...list];
        } else {
          that.hobyList = list;
        }
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.hobyList.length >= that.total) {
          that.finished = true;
        }
        // 如果总页数大于当前页码，页码+1
        if (res.data.pages > that.pageNum) {
          that.pageNum++;
        }

      })

    },
    showPopup() {
      if (this.handleType == 'check') {
        return
      }
      this.datePick = true;
    },
    showAreaPick(type) {
      if (this.handleType == 'check') {
        return
      }
      this.areaType = type;
      this.areaPick = true;
    },
    checkDate(data) {
      this.datePick = false;
      let date = new Date(data)
      this.userInfo.born = date.getFullYear() + '-' + this.p((date.getMonth() + 1)) + '-' + date.getDate()
    },
    p(s) {
      return s < 10 ? '0' + s : s
    },
    checkArae(area) {
      if (this.areaType == 'W') {
        this.userInfo.work_place = area[0].name + area[1].name + area[2].name;
      } else {
        this.userInfo.live_city = area[0].name + area[1].name + area[2].name;
      }
      this.areaPick = false;
    },
    validateIdCard(id, backInfo) {
      var info = {
        y: "1900",
        m: "01",
        d: "01",
        sex: "male",
        valid: false,
        length: 0
      },
        initDate = function (length) {
          info.length = length;
          var a = length === 15 ? 0 : 2,  // 15:18
            temp;
          info.y = (a ? "" : "19") + id.substring(6, 8 + a);
          info.m = id.substring(8 + a, 10 + a);
          info.d = id.substring(10 + a, 12 + a);
          info.sex = id.substring(14, 15 + a) % 2 === 0 ? "female" : "male";
          temp = new Date(info.y, info.m - 1, info.d);
          return (temp.getFullYear() == info.y * 1)
            && (temp.getMonth() + 1 == info.m * 1)
            && (temp.getDate() == info.d * 1);
        },
        back = function () {
          return backInfo ? info : info.valid;
        };
      if (typeof id !== "string") return back();
      // 18
      if (/^\d{17}[0-9x]$/i.test(id)) {
        if (!initDate(18)) return back();
        id = id.toLowerCase().split("");
        var wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
          y = "10x98765432".split(""),
          sum = 0;
        for (var i = 0; i < 17; i++) sum += wi[i] * id[i];
        if (y[sum % 11] === id.pop().toLowerCase()) info.valid = true;
        return back();
      }
      // 15
      else if (/^\d{15}$/.test(id)) {
        if (initDate(15)) info.valid = true;
        return back();
      }
      else {
        return back();
      }
    },
    changeTab(name) {
      var that = this;
      // if (name == "hoby") {
      //   this.getCustomerHoby();
      // } 
    },
    wordCloud() {
      var that = this;
      var i = 0;
      var oTag = null;
      //滑动范围在5x5内则做点击处理，s是开始，e是结束 
      var init = { x: 5, y: 5, sx: 0, sy: 0, ex: 0, ey: 0 };
      var sTime = 0, eTime = 0;
      for (i = 0; i < that.aA.length; i++) {
        oTag = {};

        oTag.offsetWidth = that.aA[i].offsetWidth;
        oTag.offsetHeight = that.aA[i].offsetHeight;

        that.mcList.push(oTag);
      }
      that.sineCosine(0, 0, 0);

      that.positionAll();

      that.oDiv.onmouseover = function () {
        that.active = true;
      };

      that.oDiv.onmouseout = function () {
        that.active = false;
      };

      that.oDiv.addEventListener("touchstart", function () {
        sTime = new Date().getTime();
        init.sx = event.targetTouches[0].pageX;
        init.sy = event.targetTouches[0].pageY;
        init.ex = init.sx;
        init.ey = init.sy;
        that.active = true;
        // if(type.indexOf("start") != -1) func(); 
      }, false);

      that.oDiv.onmousemove = function (ev) {
        var oEvent = window.event || ev;

        that.mouseX = oEvent.clientX - (that.oDiv.offsetLeft + that.oDiv.offsetWidth / 2);
        that.mouseY = oEvent.clientY - (that.oDiv.offsetTop + that.oDiv.offsetHeight / 2);

        that.mouseX /= 5;
        that.mouseY /= 5;
      };
      that.oDiv.addEventListener("touchmove", function () {
        // var oEvent = window.event || ev;
        event.preventDefault();//阻止触摸时浏览器的缩放、滚动条滚动 
        init.ex = event.targetTouches[0].pageX;
        init.ey = event.targetTouches[0].pageY;
        that.mouseX = init.ex - (that.oDiv.offsetLeft + that.oDiv.offsetWidth / 2);
        that.mouseY = init.ey - (that.oDiv.offsetTop + that.oDiv.offsetHeight / 2);

        that.mouseX /= 5;
        that.mouseY /= 5;
      }, false);
      that.oDiv.addEventListener("touchend", function () {
        // setTimeout(function(){
        that.doPosition();
        that.active = false;
        // },1000)

      }, false);

      this.textTimer = setInterval(that.update, 30);
    },
    update() {
      var a;
      var b;
      var per;

      if (this.active) {
        a = (-Math.min(Math.max(-this.mouseY, -this.size), this.size) / this.radius) * this.tspeed;
        b = (Math.min(Math.max(-this.mouseX, -this.size), this.size) / this.radius) * this.tspeed;
      }
      else {
        a = this.lasta * 0.98;
        b = this.lastb * 0.98;
      }

      this.lasta = a;
      this.lastb = b;

      if (Math.abs(a) <= 0.01 && Math.abs(b) <= 0.01) {
        return;
      }

      var c = 0;
      this.sineCosine(a, b, c);
      for (var j = 0; j < this.mcList.length; j++) {
        var rx1 = this.mcList[j].cx;
        var ry1 = this.mcList[j].cy * this.ca + this.mcList[j].cz * (-this.sa);
        var rz1 = this.mcList[j].cy * this.sa + this.mcList[j].cz * this.ca;

        var rx2 = rx1 * this.cb + rz1 * this.sb;
        var ry2 = ry1;
        var rz2 = rx1 * (-this.sb) + rz1 * this.cb;

        var rx3 = rx2 * this.cc + ry2 * (-this.sc);
        var ry3 = rx2 * this.sc + ry2 * this.cc;
        var rz3 = rz2;

        this.mcList[j].cx = rx3;
        this.mcList[j].cy = ry3;
        this.mcList[j].cz = rz3;

        per = this.d / (this.d + rz3);
        this.mcList[j].x = (this.howElliptical * rx3 * per) - (this.howElliptical * 2);
        this.mcList[j].y = ry3 * per;
        this.mcList[j].scale = per;
        this.mcList[j].alpha = per;

        this.mcList[j].alpha = (this.mcList[j].alpha - 0.6) * (10 / 6);
      }

      this.doPosition();
      this.depthSort();
    },
    depthSort() {
      var i = 0;
      var aTmp = [];

      for (i = 0; i < this.aA.length; i++) {
        aTmp.push(this.aA[i]);
      }

      aTmp.sort(
        function (vItem1, vItem2) {
          if (vItem1.cz > vItem2.cz) {
            return -1;
          }
          else if (vItem1.cz < vItem2.cz) {
            return 1;
          }
          else {
            return 0;
          }
        }
      );

      for (i = 0; i < aTmp.length; i++) {
        aTmp[i].style.zIndex = i;
      }
    },
    positionAll() {
      var phi = 0;
      var theta = 0;
      var max = this.mcList.length;
      var i = 0;
      var aTmp = [];
      var oFragment = document.createDocumentFragment();
      //�������
      for (i = 0; i < this.aA.length; i++) {
        aTmp.push(this.aA[i]);
      }
      aTmp.sort(
        function () {
          return Math.random() < 0.5 ? 1 : -1;
        }
      );
      for (i = 0; i < aTmp.length; i++) {
        oFragment.appendChild(aTmp[i]);
      }
      this.oDiv.appendChild(oFragment);
      for (i = 1; i < max + 1; i++) {
        if (this.distr) {
          phi = Math.acos(-1 + (2 * i - 1) / max);
          theta = Math.sqrt(max * Math.PI) * phi;
        }
        else {
          phi = Math.random() * (Math.PI);
          theta = Math.random() * (2 * Math.PI);
        }
        //����任
        this.mcList[i - 1].cx = this.radius * Math.cos(theta) * Math.sin(phi);
        this.mcList[i - 1].cy = this.radius * Math.sin(theta) * Math.sin(phi);
        this.mcList[i - 1].cz = this.radius * Math.cos(phi);

        this.aA[i - 1].style.left = this.mcList[i - 1].cx + this.oDiv.offsetWidth / 2 - this.mcList[i - 1].offsetWidth / 2 + 'px';
        this.aA[i - 1].style.top = this.mcList[i - 1].cy + this.oDiv.offsetHeight / 2 - this.mcList[i - 1].offsetHeight / 2 + 'px';
        if (i == this.mcList.length) {
          this.hotLoading = false
        }
      }
    },

    doPosition() {
      var l = this.oDiv.offsetWidth / 2 - 20;
      var t = this.oDiv.offsetHeight / 2 - 30;
      for (var i = 0; i < this.mcList.length; i++) {
        this.aA[i].style.left =
          this.mcList[i].cx + l - this.mcList[i].offsetWidth / 2 + "px";
        this.aA[i].style.top =
          this.mcList[i].cy + t - this.mcList[i].offsetHeight / 2 + "px";

        // this.aA[i].style.fontSize=Math.ceil(12*this.mcList[i].scale/2)+8+'px';

        this.aA[i].style.filter =
          "alpha(opacity=" + 100 * this.mcList[i].alpha + ")";
        this.aA[i].style.opacity = this.mcList[i].alpha;
      }
    },
    sineCosine(a, b, c) {
      this.sa = Math.sin(a * this.dtr);
      this.ca = Math.cos(a * this.dtr);
      this.sb = Math.sin(b * this.dtr);
      this.cb = Math.cos(b * this.dtr);
      this.sc = Math.sin(c * this.dtr);
      this.cc = Math.cos(c * this.dtr);
    },
    onLoad() {
      this.getCustomerHoby();
    },
    onRefresh() {
      this.searchValue = "";
      this.pageNum = 1;
      this.finished = false;
      this.getCustomerHoby();
    },
    getCard(id) {
      let that = this;
      that.$fetchGet(URL.getClueCard.url, {
        id: id,
        type: "1"
      }).then(res => {
        if (res.responseResult.responseCode === "0000") {
          that.cardInfo = res.agentCardReq;
        }
      });
    },
    shareAtc(item, idx) {
      this.shareTip = true;
      this.shareIndex = idx;
      this.articleId = item.artcid;
      let url =
        this.baseUrl +
        "article/index.html#/articleDetails?articleId=" +
        item.artcid +
        "&firstTransferPerson=" +
        this.userInfo.field1 +
        "&lastTransferPerson=" +
        this.userInfo.field1;
      this.shareLink =
        this.baseUrl +
        "article/static/html/redirect.html?app3Redirect=" +
        encodeURIComponent(url);
      this.share(item.title, item.artcsummary, this.shareLink, item.coverlink);
    },
    share(title, desc, shareLink, shareImg) {
      let that = this;
      let url = location.href.split("#")[0];
      that.$fetchGet(URL.articleShare.url, { url: url }).then(res => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: [
            "onMenuShareAppMessage",
            "onMenuShareTimeline",
            "hideMenuItems"
          ] // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImg, // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            success: function () {
              //用户确认分享后执行的回调函数
              that.$fetchPost(URL.articleShareSuccess.url, {
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.userInfo.field1,
                lastTransferPerson: that.userInfo.field1,
                activityType: "ART",
                agtid: that.userInfo.field1,
                wechatNumber: ""
              });
            },
            cancel: function () { }
          });
          wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareImg, // 分享图标
            success: function () {
              var postData = {
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.userInfo.field1,
                lastTransferPerson: that.userInfo.field1,
                activityType: "ART",
                agtid: that.userInfo.field1,
                wechatNumber: ""
              };
              // alert(_ok)
              //用户确认分享后执行的回调函数;
              that.$fetchPost(URL.articleShareSuccess.url, {
                activitieId: that.articleId,
                customerName: that.cardInfo.name,
                customerPhoneNumber: that.cardInfo.tel,
                firstTransferPerson: that.userInfo.field1,
                lastTransferPerson: that.userInfo.field1,
                activityType: "ART",
                agtid: that.userInfo.field1,
                wechatNumber: ""
              });
            }
          });
        });
      });
    }
  }
}
</script>

<style lang="less" >
.details-page {
  position: relative;
  height: 100%;
  background: #f5f5f5;
  // overflow: hidden;
  .search_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
  }
  .title {
    line-height: 40px;
    text-align: center;
    color: #333;
    font-size: 16px;
    background: #fff;
    margin-bottom: 4px;
  }
  .top {
    padding: 10px 20px;
    position: relative;
    background: #ff6927;
    font-size: 16px;
    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 1px solid #eee;
    }
    p {
      position: absolute;
      color: #fff;
      top: 30px;
      left: 90px;
      span.wxName {
        max-width: 55px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .tab {
    .van-tab__text {
      display: block;
      width: 25vw;
      margin: 0px auto;
      color: #a7a3a3;
      img {
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
      }
    }
  }
  .van-tab.van-tab--active.van-ellipsis {
    .van-tab__text {
      color: #ff6927;
    }
  }
  .detailsContent {
    padding: 10 px 0 44px;
    // height: 100%;
    background: #f5f5f5;
    display: flex;
    flex: 1;
    // overflow-y: auto;
    .van-pull-refresh {
      width: 100%;
    }
    .userInfo {
      width: 100%;
      .van-collapse-item__title {
        padding: 10px 16px;
      }
      .van-collapse-item__content {
        padding: 0;
        .van-cell {
          padding: 10px 16px;
          justify-content: space-between;
          .van-cell__value {
            flex: none;
          }
        }
        .van-radio--horizontal {
          margin-right: 0px;
          display: flex;
          flex: 1;
          padding-left: 20px;
          /* text-align: center; */
        }
      }
      .van-cell.van-field {
        padding: 10px 16px;
        input {
          font-weight: 500;
          color: #1a1a1a;
        }
      }
      .subBtn {
        line-height: 44px;
        /* display: flex; */
        text-align: center;
        margin: 16px auto;
        width: 256px;
        border-radius: 22px;
        color: #fff;
        text-align: center;
        position: relative;
        border: none;
        // border-color: #FF6927;
        background: linear-gradient(90deg, #ff6521 0%, #ffa041 100%);
        box-shadow: 0px 3px 6px #f1b1b1;
      }
    }
  }
  .hobyTitle {
    // background: #fff;
    margin-bottom: 4px;
    padding: 10px 20px;
    // text-indent: 2rem;
    color: #c2cadb;
    font-size: 14px;
    text-align: center;
  }
  .hobyList {
    // height: 100%;
    display: flex;
    flex: 1;
    background: #f5f5f5;
    // overflow-y: auto;
    .van-pull-refresh {
      width: 100%;
      .article_list {
        width: 100%;
        .van-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .list_item {
            width: 100%;
            background: #fff;
            margin-bottom: 4px;
            position: relative;
            padding: 6px 12px;
            .customer_pic_wrap {
              position: relative;
              padding: 5px 0;
              .badge {
                position: absolute;
                bottom: 4px;
                right: 0;
                width: 46px;
                height: 18px;
                line-height: 18px;
                background-color: #5b9bd5;
                color: #fff;
                text-align: center;
                font-size: 12px;
              }
            }
            .article_title {
              margin-top: 5px;
              font-size: 16px;
              color: #1a1a1a;
              position: absolute;
              width: 45%;
              top: 5px;
              left: 105px;
            }
            .editBtn {
              width: 60px;
              height: 20px;
              // background: #1f90fd;
              font-size: 12px;
              line-height: 20px;
              color: #ff6927;
              position: absolute;
              right: 12px;
              bottom: 4px;
              border-radius: 3px;
              text-align: center;
              // background: #000;
              img {
                width: 13.5px;
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
                margin-top: -3px;
              }
            }
          }
          .shareing {
            background: #f3f6f9;
            border-bottom: 0.5px solid #ccc;
          }
        }
      }
      .van-list {
        /deep/ .van-list__error-text,
        /deep/ .van-list__finished-text,
        /deep/ .van-list__loading {
          width: 100%;
        }
      }
    }
  }
  #div1 {
    position: relative;
    width: 100%;
    height: 180px;
    // margin: 30px 0;
    a {
      position: absolute;
      top: 0px;
      left: 0px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      text-decoration: none;
      padding: 6px;
      color: #fff;
      background: url(./img/wordBg.png) no-repeat;
      background-size: 100% 100%;
      display: block;
      text-align: center;
      font-size: 18px;
      width: 40px;
      height: 40px;
      line-height: 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: absolute;
      font-style: normal;
    }
    .first {
      transform: (scale(1.1));
    }
    .second {
      transform: (scale(0.9));
    }
    .third {
      transform: (scale(0.75));
    }
    .fourth {
      transform: (scale(0.6));
    }
    .fifth {
      transform: (scale(0.5));
    }
    .sexth {
      transform: (scale(0.4));
    }
    .seventh {
      transform: (scale(0.35));
    }
    .defaultText {
      width: 80%;
      margin: 0 auto;
      text-indent: 2rem;
      color: #999;
      padding-top: 25px;
    }
    .hotbg {
      width: 100%;
      height: 100%;
    }
  }
  .van-overlay {
    z-index: 1000;
    .wrapper {
      img {
        width: 70px;
        position: absolute;
        top: 5px;
        right: 20px;
      }
      h4 {
        position: absolute;
        top: 160px;
        color: #fff;
        top: 100px;
        color: #fff;
        right: 70px;
      }
    }
  }
}
.van-cell {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 30px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
}
* {
  touch-action: pan-y;
}
</style>
